import { useState, useEffect } from "react";
import _ from "lodash";
type Props = {
  __map__?: any;
  __amapui__?: any;
  keyword: string;
  adcode: number | string;
  onSearched: Function;
};

const doSearchThrottle = _.throttle(
  (onSearched, placeSearch, keyword, adcode) => {
    placeSearch.setCity(adcode || "全国");
    placeSearch.search(keyword, function (status, result) {
      if (status === "complete") {
        if (result?.info === "OK" && result?.poiList?.pois) {
          onSearched(result?.poiList?.pois, keyword);
        } else {
          onSearched([], keyword);
        }
      }
    });
  },
  500,
);

export default function PoiSearch(props: Props) {
  const { __map__, keyword, adcode, onSearched } = props;
  const [placeSearch, setPlaceSearch] = useState<any>(null);

  useEffect(() => {
    __map__.plugin(["AMap.PlaceSearch"], function () {
      setPlaceSearch(
        new AMap.PlaceSearch({
          pageSize: 20,
          pageIndex: 1, // 返回第一页结果
          extensions: "all", // 返回详细信息
          city: adcode || "全国", // 设置搜索城市
          citylimit: false, // 不限制城市，支持跨城市搜索
          autoFitView: false, // 不自动调整地图视野
        }),
      );
    });
  }, []);

  useEffect(() => {
    if (placeSearch && keyword) {
      doSearchThrottle(onSearched, placeSearch, keyword, adcode);
    }
  }, [keyword, placeSearch, adcode]);

  return null;
}
